<template>
    <div class="slice barometer-job__price">
        <div class="slice-content">
            <h2 class="slice-title">{{ t('barometer.family.average.price.title') }}</h2>
            <p>{{ t('barometer.family.average.price.subtitle', [jobBarometer.jobLabelPlural]) }} *</p>
            <figure class="barometer-job__price__value">{{ formatPrice(jobBarometer.averagePrice) }}</figure>
            <small>* {{ t('barometer.family.average.price.subtitle.amendment') }}</small>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {useTranslation} from '#imports';
    import {currenciesHelper} from '~/composables/currenciesHelper';
    import {BAROMETER_JOB} from '~/keys';

    const {jobBarometer} = inject(BAROMETER_JOB)!;
    const {formatPrice} = currenciesHelper();
    const {t} = useTranslation();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .barometer-job__price {
        &__value {
            font-family: var(--joy-font-family-title);
            margin-top: var(--joy-core-spacing-8);
            margin-bottom: var(--joy-core-spacing-4);
            color: var(--joy-color-primary-50);
            line-height: var(--joy-line-height-small);
            font-weight: var(--joy-font-weight-bold);
            font-size: var(--joy-font-size-secondary-600);

            @include mq.screen_md(min) {
                font-size: var(--joy-font-size-secondary-800);
            }
        }
    }
</style>
